import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../../LoadingSlice";
import { toast } from "react-toastify";

interface TaskListState {
  TaskList: {
    load: boolean;
    data: [];
  };
  TaskDetails: {
    load: boolean,
    data: [],
  };
  TaskImages: {
    load: boolean,
    data: [],
  };
}

export const TaskListSlice = createSlice({
  name: "TaskList",
  initialState: {
    TaskList: {
      load: false,
      data: [],
    },
    TaskDetails: {
      load: false,
      data: [],
    },
    TaskImages: {
        load: false,
        data: [],
    }
  } as TaskListState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchTaskList.pending, (state: TaskListState) => {
        state.TaskList.load = true;
      })
      .addCase(fetchTaskList.fulfilled, (state: TaskListState, action: any) => {
        state.TaskList.data = action.payload;
        state.TaskList.load = false;
      })
      .addCase(fetchTaskList.rejected, (state: TaskListState) => {
        state.TaskList.load = false;
      })
      .addCase(fetchTaskDetails.pending, (state: TaskListState) => {
        state.TaskDetails.load = true;
      })
      .addCase(fetchTaskDetails.fulfilled, (state: TaskListState, action: any) => {
        state.TaskDetails.data = action.payload;
        state.TaskDetails.load = false;
      })
      .addCase(fetchTaskDetails.rejected, (state: TaskListState) => {
        state.TaskDetails.load = false;
      })
      .addCase(fetchTaskImages.pending, (state: TaskListState) => {
        state.TaskImages.load = true;
      })
      .addCase(fetchTaskImages.fulfilled, (state: TaskListState, action: any) => {
        state.TaskImages.data = action.payload;
        state.TaskImages.load = false;
      })
      .addCase(fetchTaskImages.rejected, (state: TaskListState) => {
        state.TaskImages.load = false;
      })
      .addCase(fetchTpiTaskList.pending, (state: TaskListState) => {
        state.TaskList.load = true;
      })
      .addCase(fetchTpiTaskList.fulfilled, (state: TaskListState, action: any) => {
        state.TaskList.data = action.payload;
        state.TaskList.load = false;
      })
      .addCase(fetchTpiTaskList.rejected, (state: TaskListState) => {
        state.TaskList.load = false;
      });
  },
});

export default TaskListSlice.reducer;

export const fetchTaskList = createAsyncThunk(
  "TaskList/fetchTaskList",
  async (
    param: { apiParam: { warehouse_id: any; per_page: any, page: any, search: any } },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(toggleLoading());
      const { data } = await DataServer.post("api/getTaskOverviewData", {
        warehouse_id: param.apiParam.warehouse_id,
        per_page: param.apiParam.per_page,
        page: param.apiParam.page,
        search: param.apiParam.search,
      });
      thunkAPI.dispatch(toggleLoading());

      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
    }
  }
);

export const fetchTaskDetails = createAsyncThunk(
    "TaskDetails/fetchTaskDetails",
    async (
      param: { apiParam: { warehouse_id: any; task_pin: any } },
      thunkAPI
    ) => {
      try {
        thunkAPI.dispatch(toggleLoading());
        const { data } = await DataServer.post("api/getTaskDetails", {
          warehouse_id: param.apiParam.warehouse_id,
          task_pin: param.apiParam.task_pin,
        });
        thunkAPI.dispatch(toggleLoading());
  
        return data.data;
      } catch (error) {
        thunkAPI.dispatch(toggleLoading());
      }
    }
);
  
export const fetchTaskImages = createAsyncThunk(
    "TaskImages/fetchTaskImages",
    async (
      param: { apiParam: { warehouse_id: any; task_pin: any } },
      thunkAPI
    ) => {
      try {
        thunkAPI.dispatch(toggleLoading());
        const { data } = await DataServer.post("api/getTaskImagesData", {
          warehouse_id: param.apiParam.warehouse_id,
          task_pin: param.apiParam.task_pin,
        });
        thunkAPI.dispatch(toggleLoading());
  
        return data.data;
      } catch (error) {
        thunkAPI.dispatch(toggleLoading());
      }
    }
);

export const verifyCloseTask = createAsyncThunk(
    "TaskImages/verifyCloseTask",
    async (
      param: { apiParam: { warehouse_id: any; task_pin: any } },
      thunkAPI
    ) => {
      try {
        thunkAPI.dispatch(toggleLoading());
        const { data } = await DataServer.post("api/verifyCloseTask", {
          warehouse_id: param.apiParam.warehouse_id,
          task_pin: param.apiParam.task_pin,
        });
        toast.success(data.message,{theme: "colored"});
        thunkAPI.dispatch(toggleLoading());
  
        return data.data;
      } catch (error) {
        toast.error("Something went wrong!",{theme: "colored"});
        thunkAPI.dispatch(toggleLoading());
      }
    }
);

// TPI
export const fetchTpiTaskList = createAsyncThunk(
  "TaskList/fetchTpiTaskList",
  async (
    param: { apiParam: { warehouse_id: any; per_page: any, page: any, search: any, project_pin: any } },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(toggleLoading());
      const { data } = await DataServer.post("api/getTpiTaskOverviewData", {
        warehouse_id: param.apiParam.warehouse_id,
        per_page: param.apiParam.per_page,
        page: param.apiParam.page,
        search: param.apiParam.search,
        project_pin: param.apiParam.project_pin
      });
      thunkAPI.dispatch(toggleLoading());

      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
    }
  }
);
